// @flow
/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: File Upload component

Author: Deimos Space UK

Version: 1.0
*/
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import db from '../../../utils/db/db';
import { toast } from 'react-toastify';



const FileUpload = (props) => {
    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleAcceptedFiles = (files) => {
        var allFiles = files;
        //check if file is .oem
        if (files.length > 0) {
           
            const reader = new FileReader();
            reader.onload = () => {
                // Verificar la codificación del archivo
                const text = reader.result;
                const decoder = new TextDecoder('utf-8');
                const utfDecodedText = decoder.decode(new Uint8Array(text));
                if (!utfDecodedText) {
                    toast.warning('The file is not encoded in UTF-8')
                    // Aquí puedes manejar el archivo, por ejemplo, enviarlo a un servidor, etc.
                }
            };
        }
        if (props.showPreview) {
            files.map((file) =>
                Object.assign(file, {
                    preview: file['type'].split('/')[0] === 'image' ? URL.createObjectURL(file) : null,
                    formattedSize: formatBytes(file.size),
                })
            );

            allFiles = [...selectedFiles];
            allFiles.push(...files);
            if (allFiles.length > 1) {
                allFiles.shift()
            }
            setSelectedFiles(allFiles);
        }

        if (props.onFileUpload) props.onFileUpload(allFiles);
    };

    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };

    useEffect(() => {
        if (props.step && props.step === 'fourth') {
            const data = sessionStorage.getItem('fourthStep');
            const parsedData = JSON.parse(data);

            if (parsedData) {
                db.files.toArray().then((results) => {
                    const newFiles = results.filter((file) => file.phaseName === props.phase && file.pmd)
                    setSelectedFiles(newFiles)
                });
            }
        } else {
            const data = sessionStorage.getItem('thirdStep');
            const parsedData = JSON.parse(data);
            if (parsedData && parsedData[props.stepIndex] && parsedData[props.stepIndex][props.phase]) {
                db.files.toArray().then((results) => {
                    const newFiles = results.filter((file) => file.phaseName === props.phase && file.phaseNumber === props.indexPhase)
                    setSelectedFiles(newFiles)
                });
            }
        }

    }, [props.stepIndex, props.indexPhase, props.phase]);

    /*
     * Removes the selected file
     */
    const removeFile = (file) => {
        const fileToDelete = selectedFiles[file];
        db.files
            .where('name')
            .equals(fileToDelete.name)
            .and((file) => file.phaseName === props.phase && (file.pmd || file.phaseNumber === props.indexPhase))
            .delete()

        props.onFileDelete(props.stepIndex, props.phase, props.indexPhase);
        const newFiles = [...selectedFiles];
        newFiles.splice(newFiles.indexOf(file), 1);
        setSelectedFiles(newFiles);

    };


    return (
        <>
            <Dropzone disabled={selectedFiles.length > 0} {...props}
                accept={{
                    'application/octet-stream': ['.oem'],
                  }}
                onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}>
                {({ getRootProps, getInputProps }) => (
                    <div className="dropzone mt-1">
                        <div className="dz-message needsclick" {...getRootProps()}>
                            <input disabled={selectedFiles.length > 0} {...getInputProps()} />
                            <i className="h3 text-muted dripicons-cloud-upload"></i>
                            <p style={{ color: '#003247' }}>Drop files here or click to upload.</p>

                        </div>
                    </div>
                )}
            </Dropzone>

            {props.showPreview && selectedFiles.length > 0 && (
                <div className="dropzone-previews mt-2" id="uploadPreviewTemplate">
                    {(selectedFiles || []).map((f, i) => {

                        return (
                            <Card className="mt-1 mb-0 shadow-none border" key={i + '-file'}>
                                <div className="p-2">
                                    <Row className="align-items-center">
                                        {f.preview && (
                                            <Col className="col-auto">
                                                <img
                                                    data-dz-thumbnail=""
                                                    className="avatar-sm rounded bg-light"
                                                    alt={f.name}
                                                    src={f.preview}
                                                />
                                            </Col>
                                        )}
                                        {!f.preview && (
                                            <Col className="col-auto">
                                                <div className="avatar-sm">
                                                    <span style={{ background: '#003247' }} className="avatar-title  rounded">

                                                    </span>
                                                </div>
                                            </Col>
                                        )}
                                        <Col className="ps-0">
                                            <Link to="#" className="text-muted fw-bold">
                                                {f.name}
                                            </Link>

                                        </Col>
                                        <Col style={{ justifySelf: 'flex-end', display: 'flex' }}  >
                                            <Link to="#" className="btn btn-link btn-lg text-muted shadow-none">
                                                <i className="dripicons-cross" onClick={() => removeFile(i)}></i>
                                            </Link>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        );
                    })}
                </div>
            )}
        </>
    );
};


export default FileUpload;
